import { useQuery } from '@tanstack/react-query';
import { httpClient } from './http-client/base-client';
import { ApiTelegramAuthResponse } from './types/auth/api-types';
import { auth } from '@/components/login-modal/login-modal';

export const usePollingQuery = (uuid: string, startPolling: boolean, onSuccess: () => void) => useQuery({
    queryKey: ['polling-data', uuid],
    queryFn: async () => {
        const response = await httpClient.get<ApiTelegramAuthResponse>(`/auth/telegram?uuid=${uuid}`);
        if (response.token) {
            auth(response.token);
            onSuccess();
        }
        return response;
    },
    enabled: startPolling,
    refetchInterval: startPolling ? 2_000 : false,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
    staleTime: 0,
    retry: false
})